import { Component, Input } from "@angular/core";
import { ReportDesignItemEmpty } from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  selector: "snt-report-designer-empty",
  templateUrl: "report-designer-empty.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerEmptyComponent {
  @Input()
  item: ReportDesignItemEmpty | undefined;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "empty",
      config: {}
    };
  }
}
